<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'imgvertical',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="[15,15]">
        <a-col :sm="{span:12}" :md="{span:8}" :lg="getCol.lg(data.col)" v-for="(item,i) in data.child" :key="i">
            <div  class="bg-img flex-column align-center justify-center content-box text-white " :style="{height:height+'px',backgroundImage:'url('+addip(item.pic)+')'}">
             <h3>{{ item.name }}</h3>
             <h5 v-if="item.sub">{{ item.sub }}</h5>
              <a :href="item.url" class="opacity-50">
                <h2 ><ArrowRightOutlined /></h2>
              </a>
            </div>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="imgvertical">
import {defineComponent,defineProps,onMounted,ref } from 'vue'
import {addip,getCol} from '@/utils/util'
import {  ArrowRightOutlined } from '@ant-design/icons-vue';
defineProps({
  data:Object
})
const height=ref<Number>(640)

onMounted(()=>{
  let dom=document.querySelector(".imgvertical .content-box");
  if(dom){
    let width=dom.offsetWidth
    height.value=width*850/390  //适合竖屏手机比例
  }
})

</script>
<style lang="less">

@import '@/style/main.less';

.imgvertical {
  .content-box{
    flex-direction: column;width:100%;overflow: hidden;filter:grayscale(.6);-webkit-filter:grayscale(.6);
    h3{border-bottom: 1px solid @white;padding-bottom: 10px;}
  }
  .content-box:hover{
    box-shadow: @black-opacity-50 0 0 24px;filter:grayscale(0);-webkit-filter:grayscale(0);
    h3{border-bottom: 2px solid @primary-opacity-50;}
  }
}

</style>
